// extracted by mini-css-extract-plugin
export var caption = "quote-module--caption--BFPsQ";
export var container = "quote-module--container--DE2gn";
export var content = "quote-module--content--tP-dR";
export var description = "quote-module--description--hQMSr";
export var icon = "quote-module--icon--1lZdt";
export var subHeading = "quote-module--sub-heading--4wH93";
export var text = "quote-module--text---UNIg";